import { Text, TextColor, TextSize, TextWeight } from '@vizit/atoms';

interface AssetLabelProps {
  children: React.ReactNode;
}

function AssetLabel({ children }: AssetLabelProps) {
  return (
    <Text size={TextSize.Xs} weight={TextWeight.Medium} color={TextColor.Tertiary}>
      {children}
    </Text>
  );
}

export type { AssetLabelProps };
export { AssetLabel };
